// 🔴 N°1016 — « Rouvrir pour compléter » sous un relevé CLOS consulté dans la fiche dossier.
//
// 🔑 Le serveur décide (`rouvrable` : relevé clos ET aucun devis n'en est issu) ; l'écran ⛔ ne
//    rejoue pas la règle. Une visite terminée dont le devis a été refusé (poste sans référence)
//    redevient modifiable SANS rien perdre : mêmes postes, même identifiant.
// ⚠️ FRONTIÈRE (N°877) : vit dans `metier/artisan/` ; INJECTÉ dans le relevé par l'hôte
//    (`actionsReleve`), ⛔ le relevé reste limité à `/api/chantier/*`.
import { useEffect, useState } from "react";
import { Encart } from "../../chantier/AnnexesReleve";
import { rouvrirVisite, visitesDuDossier } from "./api";

const PRIMAIRE = { background: "var(--oh-accent-solid)", color: "var(--oh-accent-contrast)",
                   border: "none", borderRadius: 8, height: 36, padding: "0 12px", fontWeight: 500 };

export function RouvrirReleve({ releve, dossierId, onRouvert }) {
  const [visite, setVisite] = useState(null);
  const [erreur, setErreur] = useState("");
  const [envoi, setEnvoi] = useState(false);

  useEffect(() => {
    if (!releve?.id || releve.etat !== "clos" || !dossierId) return undefined;
    let vivant = true;
    visitesDuDossier(dossierId)
      .then((d) => vivant && setVisite((d.visites || []).find((v) => v.id === releve.id) || null))
      .catch(() => vivant && setVisite(null));
    return () => { vivant = false; };
  }, [releve?.id, releve?.etat, dossierId]);

  if (!visite || releve.etat !== "clos") return null;
  if (visite.devis_id) {
    return (
      <Encart ton="info" testId="reouverture-impossible">
        Un devis{visite.devis_numero ? ` (${visite.devis_numero})` : ""} est issu de cette visite : consultation seule.
      </Encart>
    );
  }
  if (!visite.rouvrable) return null;

  const rouvrir = async () => {
    setErreur(""); setEnvoi(true);
    try { await rouvrirVisite(releve.id); onRouvert && onRouvert(); }
    catch (e) { setErreur(e.message); }
    finally { setEnvoi(false); }
  };
  return (
    <section data-testid="rouvrir-releve" style={{ display: "grid", gap: 8 }}>
      <Encart ton="info" testId="rouvrir-releve-info">
        Aucun devis n'a été créé pour cette visite : vous pouvez la rouvrir pour la compléter.
        Les lignes saisies sont conservées.
      </Encart>
      <button type="button" data-testid="rouvrir-releve-bouton" onClick={rouvrir} disabled={envoi} style={PRIMAIRE}>
        {envoi ? "Réouverture…" : "Rouvrir pour compléter"}
      </button>
      {erreur && <Encart ton="error" testId="rouvrir-releve-erreur">{erreur}</Encart>}
    </section>
  );
}

export default RouvrirReleve;
